import React, { useState, useEffect } from 'react';
import { blacklistAPI } from '../api';

function Blacklist() {
  const [blacklist, setBlacklist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ phone_number: '', reason: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    loadBlacklist();
  }, []);

  const loadBlacklist = async () => {
    try {
      const response = await blacklistAPI.getAll();
      setBlacklist(response.data);
    } catch (error) {
      console.error('Error loading blacklist:', error);
      setError('Failed to load blacklist');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await blacklistAPI.add(formData);
      setShowModal(false);
      setFormData({ phone_number: '', reason: '' });
      setSuccess('Number added to blacklist');
      loadBlacklist();
    } catch (error) {
      console.error('Error adding to blacklist:', error);
      setError(error.response?.data?.error || 'Failed to add to blacklist');
    }
  };

  const handleRemove = async (id) => {
    if (window.confirm('Remove this number from blacklist?')) {
      try {
        await blacklistAPI.remove(id);
        setSuccess('Number removed from blacklist');
        loadBlacklist();
      } catch (error) {
        console.error('Error removing from blacklist:', error);
        setError('Failed to remove from blacklist');
      }
    }
  };

  if (loading) {
    return <div className="container"><div className="loading">Loading blacklist...</div></div>;
  }

  return (
    <div className="container">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1>Blacklist Management</h1>
        <button className="btn btn-primary" onClick={() => setShowModal(true)}>
          Add to Blacklist
        </button>
      </div>

      {error && <div className="error">{error}</div>}
      {success && <div className="success">{success}</div>}

      <div className="card">
        <p style={{ marginBottom: '15px', color: '#666' }}>
          Numbers in the blacklist will never receive campaign messages. Use this for opt-outs and blocked numbers.
        </p>
        {blacklist.length === 0 ? (
          <div className="empty-state">
            <h3>No blacklisted numbers</h3>
            <p>Add numbers to prevent sending messages to them</p>
          </div>
        ) : (
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Phone Number</th>
                  <th>Reason</th>
                  <th>Added</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {blacklist.map(item => (
                  <tr key={item.id}>
                    <td>{item.phone_number}</td>
                    <td>{item.reason}</td>
                    <td>{new Date(item.created_at).toLocaleString()}</td>
                    <td>
                      <button className="btn btn-danger" onClick={() => handleRemove(item.id)}>
                        Remove
                      </button>
                    </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        )}
      </div>

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Add to Blacklist</h2>
              <button className="close-btn" onClick={() => setShowModal(false)}>&times;</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Phone Number *</label>
                <input
                  type="text"
                  required
                  value={formData.phone_number}
                  onChange={(e) => setFormData({ ...formData, phone_number: e.target.value })}
                  placeholder="e.g., 5511999999999"
                />
              </div>
              <div className="form-group">
                <label>Reason</label>
                <input
                  type="text"
                  value={formData.reason}
                  onChange={(e) => setFormData({ ...formData, reason: e.target.value })}
                  placeholder="e.g., Opted out, Spam complaint"
                />
              </div>
              <div className="button-group">
                <button type="submit" className="btn btn-primary">Add to Blacklist</button>
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Blacklist;
